define('collections/payment/invoices',[
    'backbone',
    // custom
    'services/api',
    // models
    'models/payment/invoice',
    // parent
    'src/plugins/infinite-collection'
], function(
    Backbone,
    // custom
    API,
    // models
    MInvoice,
    // parents
    InfiniteCollection
) {

    var CInvoices = InfiniteCollection.extend({
        url: API.url("payments/archive/"),
        model: MInvoice,
        state: {
            pageSize: 10,
        },

        initialize: function(models, opt) {
            this.readyPromise = Backbone.$.Deferred();
        },

        parse: function(data, opt) {
            return CInvoices.__super__.parse.call(this, data, opt);
        },

        ready: function() {
            return this.readyPromise;
        }

    });

    return CInvoices;

});

